import { GoogleAuthenticateData } from "../models/google.authenticate-data.model";
import { Injectable } from "@angular/core";
import { SessionContext } from "../models/session-context.model";
import { DeviceDetectService } from "./device-detect.service";
import { StringsHelper } from "./aids/strings.helper";
import { ConditionsHelper } from "./aids/conditions.helper";
import { BiometricsAuthenticateData } from "../models/biometrics.authenticate-data.model";

@Injectable({
  providedIn: "root",
})
export class ThirdPartyConnectionService {
  googleResponseData: GoogleAuthenticateData;
  biometricsResponseData: BiometricsAuthenticateData;
  connectUserWithGoogle = false;
  connectUserWithBiometrics = false;
  checkGoogleInSession = true;
  customBrowserName: string;
  readonly currentEmailKey = "currentGoogleEmail";

  constructor(private deviceDetectService: DeviceDetectService) {
    this.customBrowserName = this.getDefaultCustomDeviceName();
  }

  get isGoogleBrowserNameError() {
    return !this.customBrowserName || this.customBrowserName.length == 0;
  }

  get googleDataInvalid() {
    return this.connectUserWithGoogle && this.isGoogleBrowserNameError;
  }

  clearData() {
    this.connectUserWithGoogle = false;
    this.googleResponseData = null;
    sessionStorage.removeItem(this.currentEmailKey);
  }

  getGoogleDataFromContext(context: SessionContext) {
    const currentEmail = sessionStorage.getItem(this.currentEmailKey);
    if (currentEmail === context.googleAuthenticateData?.email) {
      this.storeGoogleResponseData(context.googleAuthenticateData);
    }
    this.checkGoogleInSession = false;
  }

  storeGoogleResponseData(data: GoogleAuthenticateData) {
    this.googleResponseData = data;
    if (this.googleResponseData?.email) {
      sessionStorage.setItem(this.currentEmailKey, this.googleResponseData.email);
    }
  }

  getDefaultCustomDeviceName() {
    const userAgent = this.deviceDetectService.userAgent;
    if (this.deviceDetectService.isMobile) {
      if (ConditionsHelper.allObjectsExist(userAgent.device.vendor, userAgent.device.model, userAgent.browser.name)) {
        return userAgent.device.vendor + " " + userAgent.device.model + ", " + userAgent.browser.name;
      }
      return "Mobile" + StringsHelper.getWrappedStringIfExists(userAgent.os.name)
        + (userAgent.browser.name ? (", " + userAgent.browser.name) : "");

    } else {
      return "Desktop" + StringsHelper.getWrappedStringIfExists(userAgent.os.name)
        + (userAgent.browser.name ? (", " + userAgent.browser.name) : "");
    }
  }
}
